import { render } from "./BackupCreatedFrom.vue?vue&type=template&id=bd6a442a"
import script from "./BackupCreatedFrom.vue?vue&type=script&lang=js"
export * from "./BackupCreatedFrom.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__